/**
 * Created by dledinov on 25.07.14.
 */

function getDomain(){
    //Use POV domain for PROD and external INTEG test ref, when MotionPoint is configured;
     //otherwise use window.location.host for cookie
    var domain = window.location.hostname.indexOf(getPovDomain()) != -1 ? getPovDomain() : window.location.hostname;
    return domain;
}

function getPermanentCookieDate(){
    var date = new Date();
    date.setTime(date.getTime() + (1000*60*60*24*365*20)); // 1000 miliseconds, 60 seconds, 60 minutes, 24hours, 365 days, 20years
    return date;
}

function getPovDomain() {
    return '.powerofvitality.com';
}